"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var FileIcon = function FileIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#333F48' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 20 : _ref$size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.586 7.15508C16.5452 7.06675 16.4943 6.98258 16.4227 6.91092L11.4227 1.91091C11.351 1.83925 11.2668 1.78841 11.1785 1.74758C11.1535 1.73591 11.1268 1.72925 11.1002 1.72008C11.0302 1.69675 10.9585 1.68175 10.8843 1.67758C10.8668 1.67591 10.851 1.66675 10.8335 1.66675H5.00016C4.081 1.66675 3.3335 2.41425 3.3335 3.33341V16.6667C3.3335 17.5859 4.081 18.3334 5.00016 18.3334H15.0002C15.9193 18.3334 16.6668 17.5859 16.6668 16.6667V7.50008C16.6668 7.48258 16.6577 7.46675 16.656 7.44841C16.6518 7.37425 16.6377 7.30258 16.6135 7.23258C16.6052 7.20591 16.5977 7.18008 16.586 7.15508ZM13.8218 6.66675H11.6668V4.51175L13.8218 6.66675ZM5.00016 16.6667V3.33341H10.0002V7.50008C10.0002 7.96092 10.3727 8.33342 10.8335 8.33342H15.0002L15.0018 16.6667H5.00016Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.6665 10.0001H13.3332V11.6667H6.6665V10.0001ZM6.6665 13.3334H13.3332V15.0001H6.6665V13.3334ZM6.6665 6.66675H8.33317V8.33341H6.6665V6.66675Z",
    fill: color
  }));
};
var _default = FileIcon;
exports.default = _default;